<div class="position-relative headerBack" id="headerBack" [dir]="this.apiService.currentDirection"
  [ngStyle]="{'text-align': apiService.currentDirection === 'rtl'?'right':'left'}">
  <div class="container" style="min-height: 500px">
    <div class="loader" *ngIf="loader"></div>
    <div *ngIf="!loader">
      <h3 class="mt-5" style="font-weight: bold">{{'Privacy'|translate}}</h3>
      <div class="col-12">
        <div class=" py-5">
          <p class="text-justify" [innerHTML]="privacy"></p>
        </div>
      </div>
    </div>
  </div>
</div>